import { Route } from "react-router-dom";

import ForgotPassword from "components/ForgotPassword";
import ForgotPin from "components/ForgotPin";
import LayoutAuth from "components/LayoutAuth";
import Login from "components/Login";
import NewPassword from "components/NewPassword";
import DownloadAppPage from "features/ParticipantSignup/DownloadAppPage";
import JoinPage from "features/ParticipantSignup/JoinPage";
import LayoutPublic from "features/ParticipantSignup/LayoutPublic";

const PublicRoutes = (
  <>
    <Route element={<LayoutAuth />}>
      <Route path="login" element={<Login />} />
      <Route path="forgot-password" element={<ForgotPassword />} />
      <Route path="forgot-pin" element={<ForgotPin />} />
      <Route path="reset-password" element={<NewPassword />} />
    </Route>
    <Route element={<LayoutPublic />}>
      <Route path="j/:projectId/:scriptId" element={<JoinPage />} />
      <Route path="download-app" element={<DownloadAppPage />} />
    </Route>
  </>
);

export default PublicRoutes;
